<template>
  <div
    class="modal fade in"
    id="genericModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel1"
    style="display: block; padding-right: 16px;"
    >
    <div class="modal-dialog" role="document" :style="style">
      <div class="modal-content">
        <div class="modal-body" v-on-clickaway="closeModal">
          <component v-bind:is="component.bind.is" v-bind="component.bind" v-on="component.on"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'GenericModal',
  mixins: [clickaway],
  props: {
    component: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    style() {
      return { width: this.component.width };
    },
  },
  created() {},
  mounted() {
    document.body.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.closeModal();
      }
    });
  },
  methods: {
    closeModal() {
      this.$eventBus.hideModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.blur {
  background-color: rgba(0, 0, 0, 0.774);
}

.modal-content {
  z-index: 1051
}

#genericModal {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/modals/GenericModal.vue